import { render } from "./Nav_fitbar.vue?vue&type=template&id=5b277934&scoped=true"
import script from "./Nav_fitbar.vue?vue&type=script&lang=js"
export * from "./Nav_fitbar.vue?vue&type=script&lang=js"

import "./Nav_fitbar.vue?vue&type=style&index=0&id=5b277934&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b277934"]])

export default __exports__